import React, { useEffect, useState } from "react"
// import { useRef } from "react";
import sample_audio_map from './sample_audio_map'
import { storage } from "./firebase"
import { ref, getDownloadURL } from "firebase/storage";
import { CircularProgress } from "@mui/material";
import {auth , provider}  from './firebase';
import Button from '@mui/material/Button';
const sample_audios = sample_audio_map;


// import audiogif from "./sound.gif" ;

// const noise = new Audio("https://firebasestorage.googleapis.com/v0/b/als-vowel-classification.appspot.com/o/music%2F1.mp3?alt=media&token=3bd4185b-1fde-45d4-830a-7a685cb3fd23");

// import sha1 from 'sha1';
const ShowReferralForm=() => {
    // const iframeStyle = {
    //     'max-width': '100%', // Set width to 100%
    //     'max-height': '500px', // Set height to 500 pixels
    //     'border': 'none', // Remove border
    //     'marginwidth': '0',
    //     'marginheight': '0',
    //   };
    
      return (
        <div id="referral-contact-details">
            <p>If you are interested in becoming a Coordinator and  take part in the Referral process, 
                please <a id="referral-form-btn" href="https://forms.gle/mt3PrAxA9tgQQJ9W9" target="_blank">click here and fill the form</a></p>
            </div>
    )
}
const ShowConditions = ({showFull}) => {
        
    const referral_terms = (
        <>
        <li><strong>Referrals</strong></li>
            <ol><li>Person being referred to, i.e. the user who is going to take the survey, shall be henceforth called as the Referred.</li>
                <li>Person who is identifying the Referred and encouraging them to complete the survey shall be henceforth called as the Coordinator.</li>
                <li>The Coordinator shall ensure that the Referred user uses the same email address and phone number as the given by the Coordinator and these have to be different from the Coordinator's details.</li>
                <li>If the same Referred person is identified by multiple Coordinators, all Coordinator members related to this issue shall face disqualification and shall become ineligible to any remuneration amount.</li>
                <li>Coordinator shall receive the amount only after at least 10 Referred users complete the survey and pass the criteria for survey remuneration.</li>
                <li>Referral program starts only after the would-be Coordinator finishes the survey or if the would-be Coordinator is specifically approved for doing so.</li></ol>
            <li>Conditions can change at any time without prior notification or publication</li>
            
        </>
    );

    return (
        <>
        {<div id="conditions">
            <div id="conditions-list">
            <ol>
            <li>All decisions by the IISc project team are final and not open to contesting</li>
            <li>Remuneration period is only until 31 March 2026. Particpants shall not be remunerated for qualifying in the survey after this date</li>
            <li>There are <strong>two components</strong> in the advertised remuneration amount.</li>
                <ol><li>
                <strong>Rs.250</strong> for the survey (Refer to the Survey section below)
                </li>
                <li><strong>Rs.1500</strong> for referral process for 10 new users (Details shall be provided at the end of your survey)
                </li></ol>
            <li><strong>Survey</strong></li>
            <ol>
                <li>Completing the survey does not automatically entitle the user to the remuneration amount.  </li>
                <li>There is a minimum score (both accuracy and consistency) of 80% that needs to be achieved by a user in order to qualify for the remuneration amount. This score is determined by scoring of the survey entries.
                </li>
            </ol>
                {showFull ? referral_terms : null}
            </ol>
            </div>
            
        </div>}
        </>
        
    );
}

const Login = () => {
  
    // Sign in with google 

    const signin = () => {
        var btn = document.getElementById('LoginBtn');
        btn.innerHTML = "Please Wait";
        btn.ariaDisabled = true;
        auth.signInWithPopup(provider).then(function(result){
            console.log("Successful Login with " + result.user);
        }, function(error){
            console.log("Error logging in", error);
            alert(error)});
        // .catch(alert);
    }
      
    return (
        <div>

             
                <ol>
                    <li>
                 This is a survey session, where you have to grade 100 files.</li>
                <li> Use your registered gmail id only. By proceeding you <strong>agree</strong> that you have read and understood the <strong>terms and conditions</strong> below </li>
                <li> Your response will be saved if you click the <b>Next</b> button. There is no separate <b>SUBMIT</b> button</li>
                <li> For every question please wait for a few seconds for the audio to load before playing <br/>
                </li></ol>
                

                 <Button id="LoginBtn" variant="contained" onClick={signin}>Sign In with Google</Button>
            <div id="terms-and-conditions">
                <p><strong>Terms & Conditions</strong></p>
                <div id="conditions-text">
                    <ShowConditions showFull={false}/>
                </div>
            </div>
        </div>
    );
}


function InvalidLogin() {
    return (
        <>
        < hr />
            <h3>Please reload the page and login with the registered email </h3>
        </>
    )

}


function Done() {
    return (
        <div id="done">
            < hr />
            <h3>You have Completed the Survey. Thank you for your response. </h3>
            <br/>
            <p>
            We will evaluate your responses and get back to you if you have surpassed the scoring criteria
            </p>
            <div>
                <p>You can <strong>win more</strong> through our Referral process by becoming a Coordinator: <ShowReferralForm/> </p>
                <br/> <br/>
                <p><strong>Terms & Conditions:</strong></p>
            <ShowConditions showFull={true}/>
            
            </div>
        </div>
        
    )
}


function LoadQuestion(props) {
    // const [noise_counter,setNoise_counter] = useState(1);
    // const [music,setMusic] = useState(false);
    const [audioError,setAudioError] = useState(false);

    const [url, setUrl] = React.useState();
    const audioRef = props.audioRef;

    console.log("LoadQuestion Audio", props.audio);
    console.log("Inputs = ", props.inputs);
    
    

    useEffect(() => {

        function getUrl(filename) {
            console.log("getUrl Function for file ", filename);
            getDownloadURL(ref(storage, filename))
                .then((url) => {
                    setAudioError(false);
                    setUrl(url);
                }).catch((error) => {
                    console.log("There was an issue in downloading the audio. Message:", error)
                    setAudioError(true);
                });
            // setUrl("https://docs.google.com/uc?export=download&id="+filename)
        }

        getUrl(props.audio)

    }, [props.audio]);

    const handlePlay = (event) => {
        if (!audioError && url) {
            audioRef.current.play();
        } else {
            audioRef.current.pause();
        }
      }

    
    const handleAudioEnded = (event) => {
        if (!audioError) {
            props.handleEnded(true);
        }
    }

    const handleAudioError = (event) => {
        console.log("Audio Error - set to True");
        setAudioError(true)
    }

    const reloadAudio = (event) => {
        window.location.reload();
    }

    useEffect(() => {
        if (audioError) {
            console.log("There was an error loading the audio file. Please check network connection");
            // An Audio Error has occured due to Network Issues.
            // Disable the question and ask user to reload
            // audioRef.current.src="";
        }
    },[audioError]);

 return (
    <div> 
        {(!url|| audioError) && (<CircularProgress />)}

        {url && !audioError && <div className="audio-wrapper"><audio className="audio-player" 
                src={url} ref={audioRef} onEnded={handleAudioEnded}
                onError={handleAudioError}
                ></audio> 
                <Button variant="contained" onClick={handlePlay} >Play audio </Button>
                </div>
        }
        {audioError && <div id="reload-request" >
                <p className='network-error-msg'>There was a network error when loading the audio. <br/>
                    Please check your internet connection and press the Reload button below to try again. <br/>
                    If this issue persists, please try from a different device or on a more stable internet connection.<br/> </p>
                <Button variant="contained" onClick={reloadAudio} >Reload Audio</Button>
            </div>
            }

        { (props.ended && !audioError) && <p>
                        <b>
                            Please rate the quality of the audio
                        </b>
                </p>
        }
        {(props.ended && !audioError) && <div id="quality-options">
        <ul display="flex">
            <li>
                <input id="option1" 
                    className="option-radio"  
                    name="1" 
                    type="radio" 
                    value="1" 
                    onChange={props.handlechange}  
                    checked={props.inputs["1"]  == 1} 
                    required />
            <label htmlFor="option1" value="1"><strong>Class 1:</strong> There is a lot of noise and I cannot hear most of the words. And hence cannot understand what is being said
            </label>
            </li>
            <li>
                <input id="option2"
                    className="option-radio"  name="1" type="radio" 
                    value="2" onChange={props.handlechange}  
                    checked={props.inputs["1"] == 2} required />
            <label htmlFor="option2" value="2"><strong>Class 2:</strong> Inspite of noise, I can hear speech. Few words may be difficult to hear, but other words are understandable.
            </label> </li>
            <li>
                <input id="option3"
                    className="option-radio"  name="1" type="radio" 
                    value="3" onChange={props.handlechange}  
                    checked={props.inputs["1"] == 3} required />
            <label htmlFor="option3" value="3"><strong>Class 3:</strong> There is almost no noise, the speech is readily understandable          
            </label></li>
        </ul>
         
            <Button variant="contained" onClick={props.handleSubmit} >Next</Button>
          
        </div>
        }
       

    </div>
 )   
}



const handleSampleMusicPlay = (e) => {
    // Find the closest div with class "sample-audio-cell"
    const sampleAudioCell = e.currentTarget.closest('.sample-audio-cell');
    if (sampleAudioCell) {
      // Find the audio element within that cell
      const audioElement = sampleAudioCell.querySelector('.audio-player');
      if (audioElement) {
        // Play the audio
        audioElement.play();
      }
    }
  };

  const handleBreakMusicEnded = (event) => {
    // setIsBreakMusic(false);

  }

function get_src_url(class_label, sample) {
    const filename =  sample_audio_map[class_label][sample];

    
   

}


function ShowSampleAudio() {

    return (
        <table><thead><tr><th>STOI Score</th>
                <th>Sample 1
                </th>
                <th>Sample 2 
                </th>
                <th>Sample 3</th></tr></thead>
            <tbody>
              <tr><td>Class 1</td>
              <td><div className="sample-audio-cell"><audio id="class_1_sample_1" className="audio-player"
                                src={get_src_url('class1', 'sample1')} 
                                onEnded={handleBreakMusicEnded}>
                        </audio>
                        <Button 
                        className="audio-sample-button" 
                        size='sm'
                        variant="contained" 
                        onClick={handleSampleMusicPlay} >Sample 1</Button>
                </div> 
                </td>
              <td><div className="sample-audio-cell"><audio id="class_1_sample_2" className="audio-player"
                                src={get_src_url('class1', 'sample2')} 
                                onEnded={handleBreakMusicEnded}>
                        </audio>
                        <Button 
                        className="audio-sample-button" 
                        size='sm'
                        variant="contained" 
                        onClick="{handleSampleMusicPlay}" >Sample 2</Button>
                </div></td>
                <td><div className="sample-audio-cell"><audio id="class_1_sample_3" className="audio-player"
                                src={get_src_url('class1', 'sample3')} 
                                onEnded={handleBreakMusicEnded}>
                        </audio>
                        <Button 
                        className="audio-sample-button" 
                        size='sm'
                        variant="contained" 
                        onClick="{handleSampleMusicPlay}" >Sample 3</Button>
                </div>
                </td>
              </tr>
              <tr><td>Class 2</td>
              <td><div className="sample-audio-cell"><audio id="class_2_sample_1" className="audio-player"
                                src={get_src_url('class2', 'sample1')} 
                                onEnded={handleBreakMusicEnded}>
                        </audio>
                        <Button 
                        className="audio-sample-button" 
                        size='sm'
                        variant="contained" 
                        onClick="handleSampleMusicPlay()" >Sample 1</Button>
                </div> 
                </td>
              <td><div className="sample-audio-cell"><audio id="class_2_sample_2" className="audio-player"
                                src={get_src_url('class2', 'sample2')} 
                                onEnded={handleBreakMusicEnded}>
                        </audio>
                        <Button 
                        className="audio-sample-button" 
                        size='sm'
                        variant="contained" 
                        onClick="{handleSampleMusicPlay}" >Sample 2</Button>
                </div></td>
                <td><div className="sample-audio-cell"><audio id="class_2_sample_3" className="audio-player"
                                src={get_src_url('class2', 'sample3')} 
                                onEnded={handleBreakMusicEnded}>
                        </audio>
                        <Button 
                        className="audio-sample-button" 
                        size='sm'
                        variant="contained" 
                        onClick="{handleSampleMusicPlay}" >Sample 3</Button>
                </div>
                </td>
              </tr>
              <tr><td>Class 3</td>
              <td><div className="sample-audio-cell"><audio id="class_3_sample_1" className="audio-player"
                                src={get_src_url('class3', 'sample1')} 
                                onEnded={handleBreakMusicEnded}>
                        </audio>
                        <Button 
                        className="audio-sample-button" 
                        size='sm'
                        variant="contained" 
                        onClick={handleSampleMusicPlay} >Sample 1</Button>
                </div> 
                </td>
              <td><div className="sample-audio-cell"><audio id="class_3_sample_2" className="audio-player"
                                src={get_src_url('class3', 'sample2')} 
                                onEnded={handleBreakMusicEnded}>
                        </audio>
                        <Button 
                        className="audio-sample-button" 
                        size='sm'
                        variant="contained" 
                        onClick="{handleSampleMusicPlay}" >Sample 2</Button>
                </div></td>
                <td><div className="sample-audio-cell"><audio id="class_3_sample_3" className="audio-player"
                                src={get_src_url('class3', 'sample3')} 
                                onEnded={handleBreakMusicEnded}>
                        </audio>
                        <Button 
                        className="audio-sample-button" 
                        size='sm'
                        variant="contained" 
                        onClick="{handleSampleMusicPlay}" >Sample 3</Button>
                </div>
                </td>
              </tr>
              </tbody>
            </table>
    )
}

export { LoadQuestion, Login, Done, InvalidLogin, ShowConditions, ShowReferralForm, ShowSampleAudio}